var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.performance && _vm.availablity && _vm.quality)?_c('div',{staticClass:"row",attrs:{"id":"gauges-row"}},[_c('div',{staticClass:"col-12"},[_c('BarChart',{ref:"periodChart",staticStyle:{"width":"100%","height":"100%"},attrs:{"chartData":_vm.getOEEChartData,"options":_vm.getOptions()}})],1)]):_c('ComponentLoadSpinnerV2',{attrs:{"loading":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }